import config from "../../config.json";
import {
    API_ERRORS, API_SOURCE, NETWORK_RESPONSE_STATUS, BUSINESS_LAYER_RESPONSE, APPLICATION_TYPE,
    APP_INFO_PARAMS, LOGIN_CONSTANTS, API_CODES, COVER, LOCAL_STORAGE_KEYS, LOCATIONS, APP_INFO_DEFAULT_VALUES
} from "../../utils/global_variables";
import { loginSession, userProfile } from "../../apis";
import { getIsConfigExist, getUserLoggedIn, getAppInfoData, defaultLandingPage, decryptTDES, setEncryptLocalStorage, getDecryptLocalStorage, getStorageWithMultiTabCheck, setStorageWithMultiTabCheck } from "../../utils/global_functions";
import { _regExpAlphabet, _regExpNumber, _regExpSpecialCharacter } from "../settings";
import { checkGuestLogin } from "../../utils/global_functions";




function _phoneNumberValidation(value) {
    //phone no validation that only accepts numbers(no alphabest or special characters)
    if (/^(|\d+)$/.test(value)) {
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
    } else {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
    }
}

function _totpValidation(value) {
    //totp validation that only accepts numbers(no alphabest or special characters)
    if (/^(|\d+)$/.test(value)) {
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
    } else {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
    }

}

function _otpValidation(value) {
    //otp validation that only accepts numbers(no alphabest or special characters)
    if (/^(|\d+)$/.test(value)) {
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
    } else {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
    }
}


function __mobileNumberVerification(strMobileNumber) {
    //10 digit mobile no validation
    try {
        if (strMobileNumber?.length === LOGIN_CONSTANTS.MOBILE_NUMBER_LENGTH) {
            return { status: true, message: "SUCCESS", data: { mobileNumberVerification: false, mobileNumberVerificationStatus: false } };
        }
        else if (strMobileNumber?.length > LOGIN_CONSTANTS.MOBILE_NUMBER_LENGTH) {
            return { status: true, message: "SUCCESS", data: { mobileNumberVerification: true, mobileNumberVerificationStatus: true } };
        }
        else {
            return { status: true, message: "SUCCESS", data: { mobileNumberVerification: false, mobileNumberVerificationStatus: true } };
        }
    } catch (error) {
        return { status: false, message: "FAILURE", error };
    }
}


//display all uers sorted in lastlogin time 
//handled set default user 
//when clicking on Switch user(Away) to set as default
function _handleLogin(storage) {
    try {
        const arrNewUsers = [];
        let isFavourite = false;
        let activeProfile = null;
        const switchToUserId = getStorageWithMultiTabCheck(`SWITCH_TO_USER_ID`);
        for (let i = 0; i < storage.length; i++) {
            if (storage.key(i).startsWith(LOCAL_STORAGE_KEYS.USER_DETAILS)) {
                let key = storage.key(i);
                let value = getStorageWithMultiTabCheck(key);
                if (value) {
                    value = JSON.parse(value);
                    if (value?.lastLoginTime) {
                        arrNewUsers[arrNewUsers.length] = value;
                    }
                    if (switchToUserId === value?.userId) {
                        activeProfile = value;
                    }
                    else if (value?.bIsDefault === true && !switchToUserId) {
                        isFavourite = true;
                        activeProfile = value;
                    }
                    else { }
                }
            }
        }
        if (arrNewUsers?.length > 0) {
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { isFavourite, arrNewUsers, activeProfile, switchToUserId } };
        } else {
            return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
        }

    } catch (error) {
        console.log(error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }



}

function _otpAttempts(numResendOtpLimit, numOtpAttempts, numOtpTimer) {
    try {
        //numResendOtpLimit -> resend limit check
        //numOtpAttempts -> number of times otp submitted check
        //numOtpTimer -> otp timer check 
        if (numOtpAttempts <= 0 && numOtpTimer === null) {
            return { status: true, message: 'All attempts exhausted, kindly click Resend OTP', data: null };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

// function _navigateAfterLogin() {
//     try {
//         switch (APPLICATION_TYPE) {
//             case 'BREEZE':
//                 let objStorageLoginSession = getUserLoggedIn();
//                 const strNavigationPage = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.SELECTED_ROUTE);
//                 if (objStorageLoginSession) {
//                     if (objStorageLoginSession?.data?.trial_expired === false) {
//                         return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: '/watchlist' };

//                     }
//                     else if (strNavigationPage) {
//                         return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: "/" + strNavigationPage };
//                     } else {

//                         return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: "/dashboard" };
//                     }
//                 } else {
//                     return { status: false, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
//                 }
//             default:
//                 return { status: false, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
//         }
//     } catch (error) {
//         return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
//     }
// }


function _handleOTP(objAppInfo) {
    try {
        //gets the values from mobileadmin using appInfo
        let otpTimer = getAppInfoData(APP_INFO_PARAMS.APP_OTPTIMER, APP_INFO_DEFAULT_VALUES.OTP_RESEND_TIMER);
        let otpAttempts = getAppInfoData(APP_INFO_PARAMS.APP_OTP_INVALID_ATTEMPT_COUNT, APP_INFO_DEFAULT_VALUES.INVALID_OTP_ATTEMPTS);
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { otpTimer, otpAttempts } };

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

//resend otp logic
function _handleResendOTP(bSignup, objAppInfo) {
    try {

        const objOtp = _handleOTP(objAppInfo);
        if (!bSignup) {
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objOtp?.data };
        } else {
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objOtp?.data };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}



function _userType(isGuest) {

    try {
        //checks if the logged in user is guest
        if (isGuest) {
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
        } else {
            return { status: false, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}


//get userinfo of registered user (active)
function _registerationSuccessful(strRegistration) {
    try {
        switch (APPLICATION_TYPE) {
            case 'BREEZE':
                if (strRegistration === "Registration Successful") {

                    const userInfo = JSON.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));

                    return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: userInfo };
                } else {

                    return { status: false, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
                }

            default:
                return { status: false, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };

        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}



/**what is Mno  */

// function _mobileVerification(phoneNumber){
//     if (phoneNo?.length == LOGIN_CONSTANTS.MOBILE_NUMBER_LENGTH) {
//         setMobileNoVerification(false);
//         setVerifyMnoDisable(false);
//     } else if (phoneNo?.length > LOGIN_CONSTANTS.MOBILE_NUMBER_LENGTH) {
//         setMobileNoVerification(true);
//         setVerifyMnoDisable(true);
//     }
//     else {
//         setMobileNoVerification(false);
//         setVerifyMnoDisable(true);
//     }
// }


async function _userLogin(userId, password, loginType, secondAuthType, secondAuthValue, objLoginSession) {

    try {
        // dispatch(updateIsLoading(true));
        const payload = {
            "user_id": userId,
            "login_type": loginType,
            "password": password,
            "second_auth_type": secondAuthType,
            "second_auth": secondAuthValue,
            "api_key": config.Wave.ApiKey,

            "source": API_SOURCE.BREEZE,
            "version": API_SOURCE.VERSION,

        };
        //api call
        const objResp = await loginSession(payload);
        return { status: true, message: 'SUCCESS', data: objResp };
    } catch (error) {
        console.error(error.response);

        if (error?.response?.status === NETWORK_RESPONSE_STATUS.BAD_REQUEST && error?.response?.data?.errors === API_ERRORS.ECODE_INCORRECT_TOTP) {
            return { status: false, message: 'FAILURE', error: { ...error.response.data, data: objLoginSession?.data } };
        }
        else if (error?.response?.status === NETWORK_RESPONSE_STATUS.BAD_REQUEST && error?.response?.data?.code) {
            return { status: false, message: 'FAILURE', error: error.response.data };
        } else {
            return { status: false, message: 'FAILURE', error: {} };
        }
    }
};

function _isConfigPresent() {

    try {
        //is env setting present
        const isConfig = getIsConfigExist();

        if (isConfig) {
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
        } else {
            return { status: false, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
    }

}

//navigation based on user login and screen present
function _authNavigator(objAppInfo, guestLandingPage) {
    try {
        switch (APPLICATION_TYPE) {
            case 'BREEZE':
                let objStorageLoginSession = getUserLoggedIn();
                const strNavigationPage = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.SELECTED_ROUTE);
                if (objStorageLoginSession) {
                    //if guest session expired
                    if (objStorageLoginSession?.data?.trial_expired === false && guestLandingPage) {
                        if (guestLandingPage === 2) {
                            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: LOCATIONS.DASHBOARD };
                        }
                        else {
                            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: LOCATIONS.WATCHLIST };
                        }
                    }
                    //if route selected while logging in
                    else if (strNavigationPage) {
                        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: "/" + strNavigationPage };
                    }
                    else {
                        //default
                        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: defaultLandingPage(objAppInfo) };
                    }
                } else {
                    return { status: false, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
                }
            default:
                return { status: false, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: null };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

function allValuesNullOrEmpty(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            if (value !== null && value !== "") {
                return false;
            }
        }
    }
    return true;
}

function checkIfAllObjectsAreNull(arr) {
    for (const obj of arr) {
        if (!allValuesNullOrEmpty(obj)) {
            return true;
        }
    }
    return false;
}


/* Shuaib.P  SAT-BT-109047 Start  */

async function _setUserProfile() {

    /*This function checks tif all the key in the userDetails object holds a value or not */

    try {
        const apiCall = await userProfile();
        if (apiCall && apiCall?.data?.data) {
            let objResp = apiCall?.data?.data;
            if (!checkIfAllObjectsAreNull(objResp?.bank_details)) {
                objResp['bank_details'] = null;
            }

            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objResp };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

/* Shuaib.P  SAT-BT-109047 Start */

const _handleChangePasswordRegax = (value, test) => {
    /*Mahesh S  : 15-11-2023 : BT-102838 -  Breeze - regex moved before if condition - Start*/
    test.alphaRule = _regExpAlphabet.test(value.trim());
    test.numRule = _regExpNumber.test(value.trim());
    test.spcRule = _regExpSpecialCharacter.test(value.trim());
    if (value) {
        if (test.alphaRule && test.numRule && test.spcRule) {
            test.strength = "Strong";
        }
        else if ((test.alphaRule && test.numRule) ||
            (test.alphaRule && test.spcRule) ||
            (test.numRule && test.spcRule)) {
            test.strength = "Medium";
        }
        else {
            test.strength = "Weak";
        }
    } else {
        test.strength = "Weak";
    }
    /*Mahesh S  : 15-11-2023 : BT-102838 -  Breeze - regex moved before if condition - End*/
    return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: test };
};
//BT-120013 : Bug Fixing : Guest Login : Manasa B : 20/10/2023 - Start
function _handleTrialExpired(objAppInfo, userMobile,) {
    try {
        const nGuestTrialDays = getAppInfoData(APP_INFO_PARAMS.APP_GUEST_MODE_TRIAL_DAYS, objAppInfo);
        let objLocalInfo = JSON.parse(getStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${userMobile}`));
        let guestRegisteredDate = Date.parse(objLocalInfo?.data?.reg_date);
        let isTrialExpired = false;
        if (objLocalInfo) {
            if (objLocalInfo.guestMode) {
                isTrialExpired = checkGuestLogin(guestRegisteredDate, nGuestTrialDays);
            }
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: isTrialExpired };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };

    }
}
//BT-120013 : Bug Fixing : Guest Login : Manasa B : 20/10/2023 - End
//Mahesh :Login Edge Cases

const _maskedMobileNum = (number) => {
    let mobileDisplay = 'XXXXXX';
    let num = '';
    if (number) {
        num = number.substring(0, 2) + mobileDisplay + number.substring(8, number.length);
    }
    return num;
};

const _setTextDescription = (userDetails, guestResp, guestNum, objAppInfo) => {
    let flagMpinPass = getAppInfoData(APP_INFO_PARAMS.APP_EBUZZ_MODE);
    let emailDisplay = '*****';
    let mobilenumber = '';
    let otpText = '';
    if (guestNum) {
        mobilenumber = _maskedMobileNum(guestNum);
    }
    if (guestResp?.code !== API_CODES.ECODE_SUCCESS) {
        let mobile = decryptTDES(COVER.TDES, userDetails?.result?.mobile);
        if (mobile) {
            mobilenumber = _maskedMobileNum(mobile);
        }
        let emailId = decryptTDES(COVER.TDES, userDetails?.result?.email);
        if (emailId) {
            emailDisplay += emailId.substring(8, emailId.length);
        }
        if (!isNaN(parseInt(flagMpinPass))) {
            switch (flagMpinPass) {
                case 0:
                    if (mobile && emailId) {
                        otpText = `<div class="font-regular font-size4 color-text">OTP sent to <span class="font-regular">${mobilenumber}</span> & <span class="font-regular">${emailDisplay}</span></div>`;
                    }
                    else if (mobile && !emailId) {
                        otpText = `<div class="font-regular font-size4 color-text">OTP sent to <span class="font-regular">${mobilenumber}</span></div>`;
                    }
                    else if (!mobile && emailId) {
                        otpText = `<div class="font-regular font-size4 color-text">OTP sent to <span class="font-regular">${emailDisplay}</span></div>`;
                    }
                    break;
                case 1:
                    otpText = `<div class="font-regular font-size4 color-text">OTP sent to <span class="font-regular">${mobilenumber}</span></div>`;
                    break;

                case 2:
                    otpText = `<div class="font-regular font-size4 color-text">OTP sent to <span class="font-regular">${emailDisplay}</span></div>`;
                    break;
                default:
                    break;
            }
        } else {
            otpText = `<div class="font-regular font-size4 color-text">OTP sent to <span class="font-regular">${mobilenumber}</span></div>`;
        }
    }
    else {
        otpText = `<div class="font-regular font-size4 color-text">OTP sent to <span class="font-regular">${mobilenumber}</span></div>`;
    }
    return otpText;

};

function _handleBypassTOTP(objAppInfo) {
    try {
        //gets the values from mobileadmin using appInfo
        let getBypassTotp = getAppInfoData(APP_INFO_PARAMS.APP_BYPASS_TOTP);
        let isBypassTotp = '';

        if (getBypassTotp !== undefined && (getBypassTotp.toString().trim().toUpperCase() === "TRUE" || getBypassTotp.toString().trim().toUpperCase() === "ON")) {
            isBypassTotp = true;
        } else {
            isBypassTotp = false;
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { isBypassTotp } };

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
// {/* Mahesh S : 09-11-2023 : BT-97226 Subsequent Login – Profile Pic Handling – Start */ }
function _handleProfilePic(payload) {
    if (payload?.length) {
        let strProfilePath = payload[0]?.sProfilePicPath;
        if (payload[0]?.sProfilePicPath === null) {
            strProfilePath = '';
        } else if (payload[0]?.sProfilePicPath !== null && payload[0]?.sProfilePicPath?.length <= 0) {
            strProfilePath = '';
        } else { }
        setStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.PROFILE_PICTURE}_${payload[0]?.sUserId.split('_')[0]}`, strProfilePath);
    }
}
// {/* Mahesh S : 09-11-2023 : BT-97226 Subsequent Login – Profile Pic Handling – End */ }







export { _setUserProfile, _userLogin, _phoneNumberValidation, _totpValidation, __mobileNumberVerification, _otpValidation, _handleResendOTP, _handleOTP, _otpAttempts, _userType, _registerationSuccessful, _isConfigPresent, _authNavigator, _handleLogin, _handleChangePasswordRegax, _setTextDescription, _handleTrialExpired, _handleBypassTOTP, _handleProfilePic };
